export const passArgs = <T = any>() => (_, arg: T) => arg;
export const passDeeperArgs = <T = any>() => (_, __, arg: T) => arg;
